(() => {
  'use strict';
  const configNode = document.getElementById('mm-manual-ad-config');
  if (!configNode || window.__mmManualAdsV2) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (config.eligible !== true) return;
  const allowedTypes = ['page', 'article', 'blog', 'search'];
  const publicCollector = config.pageType === 'metaobject' &&
    ['mm_value_casting', 'mm_value_variation'].includes(config.recordType);
  if (!allowedTypes.includes(config.pageType) && !publicCollector) return;
  const privateHandles = new Set([
    'affiliate-program', 'affiliate-program-terms', 'collector-community',
    'collection-manager', 'my-collector-workspace', 'collector-portfolio',
    'member-center', 'hot-wheels-value-engine', 'value-engine-member-dashboard',
    'marketplace-center', 'value-engine-membership', 'value-engine-membership-benefits',
    'hot-wheels-value-engine-faq', 'hot-wheels-value-reports',
    'value-engine-member-onboarding', 'value-engine-start-here'
  ]);
  if (config.pageType === 'page' && privateHandles.has(config.pageHandle)) return;
  const isPreview = () => config.preview !== false || !!window.Shopify?.designMode ||
    !!window.Shopify?.visualPreviewMode;
  const preview = isPreview();
  if (!preview && (config.enabled !== true || !['munclemikes.com', 'www.munclemikes.com'].includes(window.location.hostname))) return;
  const slots = (Array.isArray(config.slots) ? config.slots : []).map(value => String(value || '').trim());
  if (!preview && config.client !== 'ca-pub-9353463564214157') return;
  const state = { mode: preview ? 'preview' : 'live', placements: [], skipped: [], requests: 0 };
  window.__mmManualAdsV2 = state;
  const visible = node => node.getBoundingClientRect().width >= 120 &&
    node.getClientRects().length > 0 && getComputedStyle(node).display !== 'none' &&
    getComputedStyle(node).visibility !== 'hidden' &&
    !node.closest('[hidden],[aria-hidden="true"],dialog:not([open]),details:not([open])');
  const requestAd = placement => {
    if (preview || isPreview() || placement.requested || document.visibilityState === 'hidden' || !visible(placement.element)) return;
    if (!document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')) {
      // Start Google's loader only when an approved, reserved placement is near view.
      // All placements share this script and the standard adsbygoogle request queue.
      const loader = document.createElement('script');
      loader.async = true;
      loader.crossOrigin = 'anonymous';
      loader.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + encodeURIComponent(config.client);
      document.head.append(loader);
    }
    placement.requested = true;
    if (placement.stopPendingWatch) placement.stopPendingWatch();
    if (placement.body.querySelector('ins.adsbygoogle')) return;
    placement.element.dataset.mmAdStatus = 'requested';
    const unit = document.createElement('ins');
    unit.className = 'adsbygoogle mm-manual-ad__slot';
    unit.style.display = 'block';
    unit.dataset.adClient = config.client;
    unit.dataset.adSlot = placement.slot;
    placement.body.append(unit);
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      state.requests += 1;
    } catch (_) {
      placement.element.dataset.mmAdStatus = 'request-error';
    }
  };
  const start = () => {
    // Liquid owns placement and geometry. This controller only fills a reserved body.
    const boxes = document.querySelectorAll('.mm-manual-ad[data-mm-native-ad]');
    for (const box of boxes) {
      if (state.placements.length >= 1) break;
      const position = Number(box.dataset.mmAdPosition);
      const body = box.querySelector('.mm-manual-ad__body');
      if (!body || ![1, 3].includes(position)) continue;
      const slot = slots[position - 1];
      if (!preview && !/^\d{5,20}$/.test(slot || '')) continue;
      box.dataset.mmAdMode = state.mode;
      if (preview && !body.querySelector('.mm-manual-ad__preview-title')) {
        const title = document.createElement('span');
        title.className = 'mm-manual-ad__preview-title';
        title.textContent = `${config.previewLabel} ${position}`;
        const detail = document.createElement('span');
        detail.className = 'mm-manual-ad__preview-detail';
        detail.textContent = config.previewDetail;
        body.append(title, detail);
      }
      state.placements.push({ element: box, body, slot, position, requested: false });
    }
    if (preview || !state.placements.length) return;
    if (window.MutationObserver) {
      state.placements.forEach(placement => {
        const visibilityObserver = new MutationObserver(() => {
          if (placement.requested) return;
          const rect = placement.element.getBoundingClientRect();
          if (rect.top < window.innerHeight + 180 && rect.bottom > -180) requestAd(placement);
        });
        for (let node = placement.element; node; node = node.parentElement) {
          visibilityObserver.observe(node, {
            attributes: true,
            attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'open']
          });
        }
        placement.stopPendingWatch = () => visibilityObserver.disconnect();
      });
    }
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const placement = state.placements.find(item => item.element === entry.target);
        if (placement) requestAd(placement);
        if (placement?.requested) observer.unobserve(entry.target);
      }), { rootMargin: '180px 0px', threshold: 0.01 });
      state.placements.forEach(placement => {
        const stopVisibilityWatch = placement.stopPendingWatch;
        placement.stopPendingWatch = () => {
          if (stopVisibilityWatch) stopVisibilityWatch();
          observer.unobserve(placement.element);
        };
        observer.observe(placement.element);
      });
    } else {
      state.placements.forEach(requestAd);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      state.placements.forEach(placement => {
        const rect = placement.element.getBoundingClientRect();
        if (rect.top < window.innerHeight + 180 && rect.bottom > -180) requestAd(placement);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
